import { SVGProps } from ".";

export function ModifyIcon({ color = "black", size = 18 }: SVGProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        stroke={`${color}`}
        fill="none"
        strokeWidth="0"
        viewBox="0 0 24 24"
        color={`${color}`}
        height={`${size}`}
        width={`${size}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.7266 3.99219C15.0638 3.65518 15.6191 3.64637 15.9668 3.97266L20.7373 8.44922C21.0849 8.77554 21.0928 9.3131 20.7559 9.65039L18.1729 12.2344L16.7686 16.542C16.6449 16.9213 16.3489 17.2255 15.9648 17.3662L6.16406 20.957C5.88811 21.0581 5.57603 20.9955 5.36426 20.7969L3.71875 19.2529C3.50711 19.0542 3.43284 18.7538 3.52832 18.4834L6.91992 8.87793C7.05286 8.50164 7.35685 8.20509 7.74414 8.07324L12.1436 6.57617L14.7266 3.99219ZM8.33301 9.43555L5.20117 18.3057L9.08594 14.4189L9.0791 13.9414C9.06524 13.0999 9.75843 12.406 10.627 12.3926C11.4937 12.3795 12.2066 13.0489 12.2207 13.8887C12.2346 14.7301 11.5414 15.4241 10.6729 15.4375L10.1807 15.4453L6.2959 19.3301L15.3438 16.0156L16.6328 12.0605L12.3721 8.0625L8.33301 9.43555ZM10.6484 13.8682C10.6224 13.8689 10.6016 13.8898 10.6016 13.915L10.6025 13.9619H10.6514C10.6775 13.9611 10.6985 13.9394 10.6982 13.9141C10.6976 13.8885 10.6748 13.8678 10.6484 13.8682ZM13.6426 7.19824L17.4844 10.8027L19.2119 9.07422L15.3701 5.46875L13.6426 7.19824ZM5.73535 3.00098C6.01107 3.0017 6.23451 3.22526 6.23438 3.50098L6.23242 4.75098L7.54102 4.75391C7.8168 4.75449 8.0401 4.97816 8.04004 5.25391V5.63281C8.03979 5.90906 7.81531 6.13322 7.53906 6.13281L6.23047 6.12988L6.22852 7.38184C6.22791 7.65763 6.00435 7.88101 5.72852 7.88086H5.30469C5.02866 7.88044 4.80537 7.65594 4.80566 7.37988L4.80664 6.12891L3.49902 6.12793C3.22294 6.12755 2.99971 5.90302 3 5.62695V5.24805C3.00038 4.97193 3.22486 4.7477 3.50098 4.74805L4.80859 4.75L4.81055 3.49902C4.81106 3.22293 5.03541 2.99953 5.31152 3L5.73535 3.00098Z"
          fill={`${color}`}
        />
      </svg>
    </div>
  );
}
